import axios from "axios";

const questions = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async crudQuestion(context, payload) {
            let response = await axios.post(`/crud_questions_list`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async crudCustomerQuestion(context, payload) {
            let response = await axios.post(`/crud_customer_questions`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
        async crudQuestions(context, payload) {
            let response = await axios.post(`/crud_questions`, payload);
            if (response.status === 200) {
                return response.data;
            } else {
                throw new Error('Can not load data');
            }
        },
    },
    getters: {}
}

export default questions;